import BidGroupSpecs from "./BidGroupSpecs";

export default BidGroupSpecs;
